<div class="row">
  <div class='col-lg-6 info-row'>
    <div class="info-column">
      <div class="info-section">
        <div class="info-list-2">
          <info-list-item label='Potential Bundle Id Spoofing Risk'
            labelTooltip='The risk the app may be misrepresented in advertising transactions and ads delivered to a different app or site'>
            <risk-heat-meter #value [risk]='data?.trafficOverview?.spoofingRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Location Masking Risk'
            labelTooltip='The risk that location data is inaccurate for advertising transactions involving the app'>
            <risk-heat-meter #value [risk]='data?.trafficOverview?.locationObfuscationRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Advertising IVT Risk'
            labelTooltip='The risk of advertising impressions delivered to the app being due to invalid traffic (IVT). IVT risk is derived from standardized definitions of invalid traffic maintained by the Media Ratings Council and IAB'
            (labelInteract)='goToSection("#app-ivt")'>
            <risk-heat-meter #value [risk]='data?.trafficOverview?.adFraudRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Click IVT Risk'
            labelTooltip='The risk of clicks originating from ads on the app being fraudluent'
            (labelInteract)='goToSection("#app-ivt")'>
            <risk-heat-meter #value [risk]='data?.trafficOverview?.clickFraudRisk'></risk-heat-meter>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
  <div class='col-lg-6 info-row'>
    <div class="info-column">
      <div class="info-section">
        <div class="info-list-2">
          <div class="divider d-lg-none"></div>
          <info-list-item label='Viewability Risk'
            labelTooltip='The risk of IAB viewability standards not being met for ad impressions on the app'>

            <risk-heat-meter #value [risk]='data?.trafficOverview?.viewabilityRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Est. Daily Reach' labelTooltip='Estimated daily reach of the app'
            [enableLabelInteract]='data?.trafficOverview?.dailyActiveUsers !== "N/A" '
            (labelInteract)='goToSection("#inventory-users-cont")'
            [value]='data?.trafficOverview?.dailyActiveUsers === "N/A" ? "N/A" : "up to " + (data?.trafficOverview?.dailyActiveUsers | roundsig:"0a" )'>
          </info-list-item>
          <info-list-item label='Est. Monthly Reach' labelTooltip='Estimated monthly reach of the app'
            [enableLabelInteract]='data?.trafficOverview?.monthlyActiveUsers !== "N/A" '
            (labelInteract)='goToSection("#inventory-users-cont")'
            [value]='data?.trafficOverview?.monthlyActiveUsers === "N/A" ? "N/A" : "up to " + (data?.trafficOverview?.monthlyActiveUsers | roundsig:"0a" )'>
          </info-list-item>
          <info-list-item label='Inventory'
            labelTooltip='The estimated number of monthly impressions this app makes available programmatically'
            [lock]='isFreemium' value='Est. {{data?.trafficOverview?.totalInventory | roundsig}}'></info-list-item>
          <ng-container *ngIf="hasAdSpendPermission">
            <info-list-item label='Ad Spend' [lock]='isFreemium'
              value='Est. {{data?.trafficOverview?.adSpend | roundsig}}'></info-list-item>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
